import React, {useState, useEffect} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../constants/general-constants";
import {GREY_FONT} from "../constants/general-constants";
import {CSSTransition} from 'react-transition-group';
import FilterTypeRow from '../components/FilterTypeRow';
import OvalButton from '../components/OvalButton';
import './filterwindow.css';
import {colorFunctions} from "../constants/colors";

export default function LeftMenuIconFilter({}){
	
	const defaultLabelColor = "white";
	const defaultIconColor = "white"
	const highlightColor = colorFunctions.getPrimaryAlternative();
	const rightColor = PURPLE;
	const [labelColor, setLabelColor] = useState(defaultLabelColor);
	const [iconColor, setIconColor] = useState(defaultIconColor);
	const [thisBackground, setThisBackground] = useState("");
	const [rightBorder, setRightBorder] = useState("");
	const [displayFilterWindow, setDisplayFilterWindow] = useState(false);
	
	
	const thisContainer = {
		display:"flex"
	};
	
	const iconComponentContainer = {
		display:"flex",
		width:"60px",
		height:"50px",
		alignItems:"center",
		justifyContent:"space-around",
		backgroundColor:thisBackground,
		borderRight:rightBorder,
		cursor:"pointer",
		marginTop:"10px",
		flexDirection:"column",
		marginBottom:"5px"
	};
	
	const setAsSelected = () => {
		setIconColor("white");
		setThisBackground(highlightColor);
	};
	
	const setUnSelected = () => {
		setIconColor("white");
		setThisBackground("");
	};
	
	const setHover = () => {
		setLabelColor("white");
		setIconColor("white");
		setThisBackground(highlightColor);
		//setRightBorder("3px solid " + rightColor);
	};
	
	const setUnhover = () => {
		setLabelColor(defaultLabelColor);
		setIconColor(defaultIconColor);
		setThisBackground("");
		setRightBorder("");
	};
	
	const handleMouseOver = () => {
		setHover();
	};
	
	const handleMouseOut = () => {
			setUnhover();
	};
	
	const iconStyle = {
		display:"flex",
		width:"22px",
		height:"22px",
		color:iconColor
	};
	
	const iconLabel = {
		display:"flex",
		alignSelf:"center",
		fontSize:"12px",
		color:labelColor
	};
	
	const goFilter = () => {
		setDisplayFilterWindow(!displayFilterWindow);
	};
	
	
	const infoBox = {
  	display:"flex",
  	width:"450px",
  	backgroundColor:"white",
  	color:"#000",
  	flexDirection:"column",
  	height:"100%"
  };
  
  const infoBoxHeader = {
		display:"flex",
		width:"100%",
		//justifyContent:"space-between",
		backgroundColor:colorFunctions.getPrimaryAlternative()
	};
	
	const infoBoxTitle = {
			display:"flex",
			height:"40px",
			color:"white",
			fontSize:"16px",
			paddingLeft:"20px",
			alignItems:"center"
	};
			
			
	const filterContainer ={
		display:"flex",
		alignItems:"center",
		height:"100%",
	};
	
	const arrowHolder = {
		display:"flex",
		width:"40px",
		height:"40px",
		backgroundColor:"white",
		alignItems:'center',
		justifyContent:"space-around",
		borderRadius:"20px",
		boxShadow:'0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.08)',
		zIndex:"1000",
		marginLeft:"-20px"
	};
	
	const iconStyleFilter = {
		display:"flex",
		width:"22px",
		height:"22px",
		color:colorFunctions.getSecondaryColor(),
		cursor:'pointer'
	};
	
	const filterTypes = [
		{title:'Project Type', filters:[
				{label:'Refurbishment', 
					filters:[
						{label:'Premier', filters:[]},
						{label:'Flagship', filters:[]}
					]	
				}
			]
		},
		{title:"Building Type", filters:[
				{label:'Branch', filters:[]},
				{label:'Data Centre', filters:[]}
			]	
		}
	];
	
	const filterTypeContainer = {
		display:"flex",
		flexDirection:"column",
		width:"100%",
		height:"calc(100% - 110px)",
		overflow:"auto"
	};
	
	const filterTypeDisplay = filterTypes.map((item, index) =>
		<FilterTypeRow
			label={item.title}
			filters={item.filters}
		/>
	);
	
	const applyFilter = () => {
		setDisplayFilterWindow(false);
		setAsSelected();
	};
	
	const clearFilter = () => {
		setUnSelected();
	};
	
	const filterButtonContainer = {
		display:"flex",
		alignSelf:"center"
	};

	
	return (
		<div style={thisContainer}>
			<div style={iconComponentContainer} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onClick={goFilter}>
				<FontAwesomeIcon icon="filter" style={iconStyle} />
				<div style={iconLabel}>
					Filter
				</div>
			</div>
			<CSSTransition
				    in={displayFilterWindow}
				    classNames="filterwindow"
				    timeout={1000}
				    appear={false}
			>
			<div className="filterwindow">
				<div style={filterContainer}>
					<div style={infoBox}>
						<div style={infoBoxHeader}>
								<div style={infoBoxTitle}>
									Filter
								</div>
						</div>
						<div style={filterTypeContainer}>
								{filterTypeDisplay}
						</div>
						<div style={filterButtonContainer}>
							<OvalButton
								label="Apply Filter"
								clickFunction={applyFilter}
							/>
							<OvalButton
								label="Clear Filter"
								clickFunction={clearFilter}
							/>
						</div>
					</div>
					<div style={arrowHolder}>
						<FontAwesomeIcon icon="angle-left" style={iconStyleFilter} onClick={goFilter}/>
					</div>
				</div>
			</div>
		</CSSTransition>
		</div>
	);
}